import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconTrendingDown = createIcon({
  displayName: 'IconTrendingDown',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M16.5891 14H17.9991V12.59L12.9991 7.59004L8.49906 12.09L2.70906 6.29004L1.28906 7.71004L8.49906 14.91L12.9991 10.41L16.5891 14ZM20 10H22V18H14V16H20V10Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
